<template>
	<div class="tw-flex tw-h-full tw-flex-col tw-justify-between">
		<div>
			<div>
				<div class="tw-mb-3 tw-text-[32px] tw-font-bold tw-text-gray-950">
					{{ $t('integrations.add-a-payment-method') }}
				</div>
				<div class="tw-text-2xl tw-font-medium tw-text-gray-950">
					{{ $t('integrations.add-a-payment-method-desc') }}
				</div>
			</div>

			<div class="tw-mt-5 tw-flex tw-gap-3">
				<AppButton
					:label="$t('integrations.skip-step')"
					size="xl"
					class="tw-rounded-full"
					type="button"
					@click="skipStep"
					:disabled="skipStepLoading"
					:loading="skipStepLoading"
					secondary
					variant="gray"
				/>

				<a
					href="https://business.facebook.com/business/loginpage/?next=https%3A%2F%2Fbusiness.facebook.com%2Fbilling_hub%2Fpayment_settings%2F%3Fasset_id%3D357255454146186"
					target="_blank"
				>
					<AppButton
						:label="$t('integrations.add-payment-method')"
						size="xl"
						class="tw-rounded-full"
						variant="brand"
						customClasses="tw-gap-3"
						endIcon="assets/v2/image/icons/arrow-up-right.svg"
					/>
				</a>
			</div>
		</div>

		<div v-if="configs.brand == 'Linker'" class="tw-mt-7 tw-flex tw-justify-end">
			<a :href="needHelpUrl" target="_blank">
				<AppButton
					:label="$t('integrations.need-help')"
					variant="secondary"
					endIcon="assets/v2/image/icons/help-circle.svg"
					class="tw-rounded-full"
					size="xl"
				/>
			</a>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { useLinkMarketplaceStore } from '@/v2/modules/integrations/stores/link-marketplace';
import { Marketplace } from '@/v2/modules/integrations/entities/marketplace';
import { configs } from '@/v2/system-configs';

const linkMarketplaceStore = useLinkMarketplaceStore();

const needHelpUrl =
	'https://www.linker.com.sa/help-center-articles-ar/how-to-add-a-payment-method-to-your-meta-business-account';
const skipStepLoading = ref(false);

const skipStep = async () => {
	skipStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
	} finally {
		skipStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
